import "./css/bootstrap.min.css";
import "./css/tooplate-infinite-loop.css";

import React, { useState, useEffect } from "react";
import { FadeLoader } from "react-spinners";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";

import Login from "./app/Screens/public/Login";
import Public from "./app/Screens/public/index";
import Secure from "./app/Screens/secure/index";
import VerifyPage from "./app/Screens/public/VerifyNumber";
import ConfirmationPage from "./app/Screens/public/ConfirmEmail";
import ResetPassword from "./app/Screens/public/ResetPassword";
import EditProfile from "./app/Screens/secure/EditProfile";
import Register from "./app/Screens/public/Register";
import ForgotPassword from "./app/Screens/public/ForgotPassword";
import RegisterNumber from "./app/Screens/public/RegisterNumber";
import MyBookings from "./app/Screens/secure/MyBookings/bookings";
import ParentCalendar from "./app/Screens/secure/ParentCalendar";
import CalendarNew from "./app/Screens/secure/CalendarNew";

import { AlertProvider } from "./app/context/AlertContext";
import { UserProvider } from "./app/context/UserContext";

import useVisibilityChange from "./useVisibilityChange";
import NotificationManager from "./app/components/notification";
import {
  toastNotification,
  sendNativeNotification,
} from "./notificationHelper";
import MagicLogin from "./app/Screens/public/MagicLogin";

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState();
  const [notification, setNotification] = useState(null);
  const [message, setMessage] = useState(null);
  const [path, setPath] = useState("");
  const isForeground = useVisibilityChange();

  const navigate = useNavigate(); // useNavigate works now because App is inside Router

  const loginVerification = () => {
    console.log("Login verification called");
    setAuthenticated(true);
    setPath("/");
    navigate("/");
  };

  const checkUser = () => {
    const token = localStorage.getItem("token");

    if (token) {
      setAuthenticated(true);
      setLoading(false);
    } else {
      setAuthenticated(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("usao u useEffect");
    checkUser();
  }, []);

  return (
    <div className="App">
      {loading ? (
        <div className="spinner-loader">
          <FadeLoader />
        </div>
      ) : (
        <Routes>
          <Route
            path="/magic-login"
            element={<MagicLogin loginVerification={loginVerification} />}
          />

          <Route
            path="/verify/:guid"
            element={<VerifyPage loginVerification={loginVerification} />}
          />
          <Route path="/confirmation" element={<ConfirmationPage />} />
          <Route
            path="/register"
            element={<Register loginVerification={loginVerification} />}
          />
          <Route
            path="/login"
            element={<Login loginVerification={loginVerification} />}
          />
          <Route path="/forgotpassword/:guid" element={<ResetPassword />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/signinphone" element={<RegisterNumber />} />

          {!authenticated ? (
            <Route
              path="/"
              element={<Public loginVerification={loginVerification} />}
            />
          ) : (
            <>
              <Route path="/" element={<CalendarNew checkUser={checkUser} />} />
              <Route path="/my-bookings" element={<MyBookings />} />
              <Route path="/edit_profile" element={<EditProfile />} />
            </>
          )}
        </Routes>
      )}
    </div>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <AlertProvider>
        <UserProvider>
          <App />
        </UserProvider>
      </AlertProvider>
    </Router>
  );
}
